export default __webpack_public_path__ + "6f88c3ce3104deaa74aad68c411b9c49.png";